<template>
  <section
    :class="{ paymentStatusSuccess: paymentStatus === 'successCreated' }"
    class="promo__codes-form-wrap media-buying-modal add-public-modal"
  >
    <Modal
      v-model:show="active"
      @close="close"
    >
      <template v-slot:header>
        <h5 class="modal-title">
          <template v-if="form.id">
            <span class="incrementing-id"> (ID: {{ form.incrementing_id }}) </span>
            {{ $t('mediaBuying.campaign.payment') }}
          </template>
          <template v-if="!form.id">
            {{ $t('mediaBuying.campaign.request_payment') }}
          </template>
        </h5>
      </template>
      <div>
        <form v-if="paymentStatus === 'successCreated'">
          <div class="successPaymentBlock">
            <div>
              <img
                :src="okImg"
                alt
              >
            </div>
            <div class="title">
              {{ $t('mediaBuying.campaign.payment_request_created_message') }}
            </div>
            <div
              class="message"
              v-html="$t('mediaBuying.campaign.payment_request_success_message')"
            />
          </div>
        </form>
        <form v-else>
          <div
            v-if="form.id"
            class="comment-overflow"
          >
            <div
              v-for="(comment, index) in comments"
              :key="index"
              class="comment-wrap__wrap"
            >
              <div class="comment-wrap__mess">
                <div
                  v-if="comment.author_type === 'admin'"
                  class="aff-text-left mb-8"
                >
                  <span class="comment-wrap__mess-text comment-wrap__mess-text-left">
                    <span class="date">
                      {{ $filters.formatDate3(comment.created_at) }}
                    </span>
                    <span class="comment-wrap__mess-text-row">{{ comment.content }}</span>
                    <a
                      v-for="(file, ind) in comment.files"
                      :key="ind"
                      :download="file.filename"
                      :href="file.download_url"
                      class="comment-wrap__mess-files mb-4 mr-4"
                      target="_blank"
                    >
                      <span class="file-name">{{ file.filename }}</span>
                      <i class="fas fa-download pl-4" />
                    </a>
                  </span>
                </div>
                <div
                  v-if="comment.author_type === 'affiliate'"
                  class="aff-text-right !tw-text-right mb-8"
                >
                  <span
                    :class="{ editable: editIndexComment === index }"
                    class="comment-wrap__mess-text comment-wrap__mess-text-right"
                  >
                    <span class="comment-wrap__content">
                      <span
                        v-if="(form.moderation_status === 'for_rework' || form.payout_status === 'for_rework') && hideEditAndDelete(comment)"
                        class="comment-wrap__control"
                      >
                        <span class="date">
                          {{ $filters.formatDate3(comment.created_at) }}
                        </span>
                        <i
                          v-if="editIndexComment !== index"
                          class="fas fa-pen pl-4"
                          @click="editMessage(comment, index)"
                        />
                        <i
                          v-if="editIndexComment !== index"
                          class="fas fa-times pl-4"
                          @click="deleteMessage(comment, index)"
                        />
                      </span>
                      <span class="comment-wrap__mess-text-row">{{ comment.content }}</span>
                      <a
                        v-for="(file, ind) in comment.files"
                        :key="ind"
                        :download="file.filename"
                        :href="file.download_url"
                        class="comment-wrap__mess-files mb-4 mr-4"
                        target="_blank"
                      >
                        <span class="file-name-wrap">
                          <span class="file-name">{{ file.filename }}</span>
                          <i class="fas fa-download pl-4" />
                        </span>
                      </a>
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="form.id"
            class="comment-wrap__inn mt-8"
          >
            <div class="!tw-flex comment-wrap">
              <div>
                <div class="form-group select-wrapper m-0 !tw-w-full">
                  <textarea
                    v-model="comment"
                    :disabled="!(form.moderation_status === 'for_rework' || form.payout_status === 'for_rework')"
                    :placeholder="$t('mediaBuying.campaign.comment')"
                    class="form-control form-control-ta"
                  />
                </div>
                <button
                  v-if="flagEditComment"
                  :disabled="!(form.moderation_status === 'for_rework' || form.payout_status === 'for_rework')"
                  class="btn btn-outline-danger btn-sm btn-icon ml-8"
                  @click.prevent="resetEdit"
                >
                  <i class="fas fa-times text-red" />
                </button>
                <button
                  :disabled="isDisabledBtnComment || !comment"
                  class="btn btn-outline-primary !tw-flex !tw-items-center !tw-justify-center btn-sm ml-8"
                  @click.prevent="preloadImage"
                >
                  <img
                    :src="okImg"
                    alt=""
                    height="12"
                  >
                  <span class="ml-4">{{ $t('mediaBuying.campaign.send') }}</span>
                </button>
              </div>
            </div>
            <div class="form-group select-wrapper file-wrap file-wrap-comment mb-0 mt-0">
              <ElUpload
                :auto-upload="false"
                :class="{
                  disabled:
                    fileListComment.length === $store.state.mediaBuying.uploadSettingsData.max_files_per_request,
                }"
                :file-list="fileListComment"
                :on-change="onSuccessComment"
                :on-remove="handleRemoveComment"
                action=""
                class="upload-demo"
                multiple
              >
                <button
                  class="btn btn-outline-primary btn-sm btn-icon"
                  @click.prevent
                >
                  <i class="fas fa-paperclip" />
                </button>
              </ElUpload>
              <span
                v-if="errorFile.length"
                class="error error-file text-danger !tw-text-left mt-2"
              >
                {{ errorFile[0] }}
              </span>
            </div>
          </div>
          <div
            v-if="form.id"
            class="statuses pay-info-wrap !tw-flex mb-8 mt-4 pt-10"
          >
            <div class="select-wrapper mr-32">
              <UiLabel :label="$t('mediaBuying.payments.fields.moderation_status.title')" />
              <span v-html="formatStatus(form.moderation_status)" />
            </div>
            <div class="select-wrapper mr-32">
              <UiLabel :label="$t('mediaBuying.payments.fields.payout_status.title')" />
              <span v-html="formatStatus(form.payout_status)" />
            </div>
          </div>
          <div class="!tw-flex mobile-flex-column">
            <div class="select-wrapper !tw-w-full mb-0">
              <UiSelect
                v-model="form.site_payment_method_id"
                v-model:error="error.site_payment_method_id"
                :label="$t('mediaBuying.campaign.payment_type')"
                :list="paymentList"
                :placeholder="$t('profile.generalInfo.notSpecified')"
                error-clear-on-change
                is-search
                @change="(form.payment_wallet = ''); form.currency_code = ''; (error.site_payment_method_id = '')"
              />
            </div>
            <div class="form-group select-wrapper !tw-w-full ml-16 mb-0 mt-0">
              <UiInput
                v-model="form.payment_wallet"
                v-model:error="error.payment_wallet"
                :disabled="form.site_payment_method_id === ''"
                :label="$t('mediaBuying.campaign.wallet')"
                :placeholder="wallet_placeholder"
              />
            </div>
          </div>

          <div class="!tw-flex mobile-flex-column mobile-flex-column-period">
            <div class="form-group select-wrapper per-wrap">
              <UiDatePicker
                v-model="form.payment_period_start"
                v-model:error="error.payment_period_start"
                :default-time="new Date(2000, 1, 1, 0, 0, 0)"
                :label="$t('mediaBuying.campaign.payment_period_start')"
                :placeholder="$t('mediaBuying.campaign.specify_period')"
                format="DD MMM YYYY HH:mm"
                prepend-icon="calendar-alt"
                type="datetime"
              />
            </div>
            <div class="form-group select-wrapper per-wrap ml-16">
              <UiDatePicker
                v-model="form.payment_period_end"
                v-model:error="error.payment_period_end"
                :default-time="new Date(2000, 2, 1, 23, 59, 59)"
                :label="$t('mediaBuying.campaign.payment_period_end')"
                :placeholder="$t('mediaBuying.campaign.specify_period')"
                format="DD MMM YYYY HH:mm"
                prepend-icon="calendar-alt"
                type="datetime"
              />
            </div>
          </div>

          <div class="!tw-flex mobile-flex-column">
            <div
              :class="{ 'disable-input': form.site_payment_method_id === '' }"
              class="select-wrapper !tw-w-full"
            >
              <UiSelect
                v-model="form.currency_code"
                v-model:error="error.currency_code"
                :label="$t('dashboard.currency')"
                :list="currencyList"
                :placeholder="$t('profile.generalInfo.notSpecified')"
                error-clear-on-change
                is-search
              />
            </div>
            <div class="form-group select-wrapper sum-wrap mb-8 mt-0 ml-16">
              <UiInput
                v-model="form.amount"
                v-model:error="error.amount"
                :label="$t('mediaBuying.campaign.sum')"
                :placeholder="$t('mediaBuying.campaign.sum')"
                error-clear-on-change
              />
            </div>
          </div>

          <UiLabel label="URL" />
          <div class="urls-wrap-out form-group select-wrapper mb-8 mt-0">
            <div
              v-for="(url, i) in form.urls"
              :key="i"
              class="urls-wrap"
            >
              <UiInput
                v-model="form.urls[i]"
                :error="error.urls?.[i]"
                class="mb-10"
                placeholder="URL"
                @input="
                  error.urls && error.urls[i] ? (error.urls[i] = '') : ''
                "
              />
              <a
                class="btn-cross"
                href="#"
                @click.prevent="popUrl(i)"
              >×</a>
            </div>
            <button
              class="btn btn-outline-primary btn-sm"
              @click.prevent="addUrl"
            >
              + {{ $t('mediaBuying.campaign.add_another_url') }}
            </button>
          </div>

          <div class="form-group select-wrapper mb-8">
            <UiLabel :label="$t('mediaBuying.campaign.description')" />
            <ElInput
              v-model="form.description"
              :autosize="{ minRows: 3, maxRows: 8 }"
              :class="[
                {'textarea_error': error.description,}
              ]"
              :placeholder="$t('mediaBuying.campaign.description')"
              class="no-border form-control-lg textarea-autosize"
              maxlength="1024"
              type="textarea"
              @input="error.description = ''"
            />

            <UiHelp
              v-if="error.description"
              :is-error="true"
              :text="error.description[0].message"
            />
          </div>
          <div class="form-group select-wrapper file-wrap mb-0">
            <UiLabel :label="$t('mediaBuying.campaign.files')" />
            <div class="file-wrap__info">
              {{
                `${$t('mediaBuying.campaign.up_to')} ${$store.state.mediaBuying.uploadSettingsData.max_files_per_request} ${$t(
                  'mediaBuying.campaign.files2',
                )},
                ${$t('mediaBuying.campaign.max')} ${$store.state.mediaBuying.uploadSettingsData.max_upload_bytes / 1024 / 1024}${$t(
                    'mediaBuying.campaign.mb_each',
                )}`
              }}
            </div>
            <ElUpload
              :auto-upload="false"
              :class="{
                disabled: fileList.length === $store.state.mediaBuying.uploadSettingsData.max_files_per_request,
              }"
              :file-list="fileList"
              :on-change="onSuccess"
              :on-remove="handleRemove"
              action=""
              class="upload-demo"
              drag
              multiple
            >
              <div class="el-upload__text">
                {{ $t('mediaBuying.campaign.dnd') }}
                <span class="text-green">{{ $t('mediaBuying.campaign.select_file') }}</span>
              </div>
            </ElUpload>
            <span
              v-if="errorFileDown.length"
              class="error error-file text-danger !tw-text-right mt-2"
            >
              {{ errorFileDown[0] }}
            </span>
          </div>
        </form>
      </div>
      <template v-slot:footer>
        <div
          v-if="paymentStatus === 'successCreated'"
          class="successPaymentFooter"
        >
          <a
            class="btn btn-primary btn-sm"
            @click="close"
          >
            <span>{{ $t('mediaBuying.campaign.got_it') }}</span>
          </a>
        </div>
        <div
          v-else
          class="!tw-text-right !tw-flex !tw-items-baseline"
        >
          <a
            class="btn btn-outline-primary btn-sm"
            @click="close"
          >
            {{ $t('promoCodes.addPromocodes.cancel') }}
          </a>
          <a
            :disabled="loading || undefined"
            class="btn btn-primary btn-sm ml-16"
            @click="requestSend"
          >
            <span v-if="!loading">{{ $t('mediaBuying.campaign.request_payment') }}</span>
            <i
              v-if="loading"
              class="fas fa-spinner spinner-hide"
            />
          </a>
        </div>
      </template>
    </Modal>
  </section>
</template>

<script>
import { Modal } from '@/components';
import eventBus from '@/lib/eventBus';
import okImg from '@/assets/theme/icon/ok.svg';
import _ from '@/lib/lodash';
import editMessages from './mixins/editMessages';
import uploadFileDragAndDrop from './mixins/uploadFileDragAndDrop';

const classes = {
  approved: 'text-green',
  on_review: 'text-orange',
  declined: 'text-red',
  paid: 'text-green',
  processing: 'text-orange',
  not_paid: 'text-red',
  for_rework: 'text-red',
  failed: 'text-red',
};

export default {
  components: {
    Modal,
  },
  mixins: [editMessages, uploadFileDragAndDrop],
  emits: ['addPayment'],
  data() {
    return {
      fileListBack: [],
      fileListCommentBack: [],
      saveImageDefaultAdd: [],
      errorFileDown: [],
      idNeedsDeleted: [],
      fileListDouble: [],
      fileListDoubleComment: [],
      fileList: [],
      fileListComment: [],
      countFile: 0,
      countFileComment: 0,
      comment: '',
      comments: [],
      formComment: {
        content: '',
        file_ids: [],
      },
      active: false,
      form: {
        site_payment_method_id: '',
        payment_period_start: '',
        payment_period_end: '',
        currency_code: '',
        file_ids: [],
        urls: [''],
      },
      fileListBackup: [],
      fileIdsBackup: [],
      error: [],
      loading: false,
      amount: '',
      paymentStatus: '',
    };
  },
  props: ['id'],

  computed: {
    okImg: () => okImg,
    currencyList() {
      const paymentMethod = this.paymentList.find(({ id }) => id === this.form?.site_payment_method_id);
      const { currency_code } = this.form;
      if (paymentMethod?.allowed_currencies === 'selected') {
        return this.$_.uniqBy([...paymentMethod.currencies, ...(currency_code ? [{ currency_code }] : [])], 'currency_code')
          .map(({ currency_code }) => this.$store.state.misc.currencies.find(({ code }) => code === currency_code))
          .map((cur) => ({ id: cur.code, text: cur.name }));
      }

      return this.$store.state.misc.currencies
        .map((cur) => ({ id: cur.code, text: cur.name }));
    },
    paymentList() {
      return this.$store.state.mediaBuying.paymentMethod
        .map((e) => ({
          ...e,
          text: e.name,
        }));
    },
    wallet_placeholder() {
      if (this.paymentList.length) {
        const payment = this.paymentList.find((e) => e.id === this.form.site_payment_method_id) || {};
        return payment.wallet_placeholder;
      }

      return '';
    },
  },
  methods: {
    popUrl(i) {
      this.form.urls.splice(i, 1);
    },
    addUrl() {
      this.form.urls.push('');
    },
    getComments() {
      this.getCommentsPayment(this.form.id);
    },
    open(row) {
      this.active = true;
      this.paymentStatus = '';
      this.form.currency_code = '';

      if (row && row.id) {
        this.getCommentsPayment(row.id);
        const pickQuery = [
          'id',
          'incrementing_id',
          'moderation_status',
          'payout_status',
          'currency_code',
          'site_payment_method_id',
          'payment_period_end',
          'payment_period_start',
          'payment_wallet',
          'amount',
          'description',
          'file_ids',
          'files',
        ];

        const urls = row.urls.length ? row.urls.map((el) => el.url) : [''];

        this.form = {
          ...this.$_.pick(row, pickQuery),
          urls,
          currency_code: row.currency_code,
        };

        this.idNeedsDeleted = this.$_.cloneDeep(this.form.files.map((file) => file.id));
        this.form.file_ids = this.$_.cloneDeep(this.idNeedsDeleted);

        this.fileList = row.files.map((e) => ({
          status: 'ready',
          name: e.filename,
          id: e.id,
        }));
      }
    },
    close() {
      this.active = false;
      this.reset();
    },
    reset() {
      this.resetEdit();
      this.errorFile = [];
      this.errorFileDown = [];
      this.error = [];
      this.fileList = [];
      this.form = {
        site_payment_method_id: '',
        payment_period_start: '',
        payment_period_end: '',
        file_ids: [],
        urls: [''],
      };
      this.comments = [];
      this.fileListComment = [];
      this.comment = '';
      this.formComment = {
        content: '',
        file_ids: [],
      };
    },
    send() {
      this.loading = true;
      this.paymentStatus = '';

      this.form.payment_period_start = this.form.payment_period_start
        ? moment(this.form.payment_period_start).format('YYYY-MM-DD HH:mm:00')
        : '';
      this.form.payment_period_end = this.form.payment_period_end
        ? moment(this.form.payment_period_end).format('YYYY-MM-DD HH:mm:00')
        : '';

      const urlsFiltered = this.form.urls.filter((e) => e !== '');
      this.form.urls = urlsFiltered.length ? urlsFiltered : [''];

      if (!this.form.id) {

        this.$store
          .dispatch('createPayment', {
            ...this.form,
            campaign_id: this.$store.state.mediaBuying.campaign.id,
          })
          .then(() => {
            this.$emit('addPayment', 'silent', 'hard');
            this.paymentStatus = 'successCreated';
          })
          .catch((err) => {
            this.error = err.response.data.errors;
            this.fileList = this.$_.cloneDeep(this.fileListBackup);
            this.form.file_ids = [];
          })
          .finally(() => {
            this.$nextTick(() => {
              this.loading = false;
            });
          });
      } else {
        this.$store
          .dispatch('editPayment', {
            ...this.form,
            status: 'on_review',
          })
          .then(() => {
            eventBus.$emit('addPayment', undefined, 'hard');
            this.close();
            this.$alert.success(this.$t('mediaBuying.campaign.payment_request_edited_message'));
          })
          .catch((err) => {
            this.error = err.response.data.errors;
            this.fileList = this.$_.cloneDeep(this.fileListBackup);
            this.form.file_ids = [];
          })
          .finally(() => {
            this.$nextTick(() => {
              this.loading = false;
            });
          });
      }
    },
    postCommentsPayment(id) {
      this.loading = true;
      this.formComment.content = this.comment;
      this.$store
        .dispatch('postPaymentComments', { id, ...this.formComment })
        .then(() => {
          this.comment = '';
          this.formComment = {
            content: '',
            file_ids: [],
          };
          this.getCommentsPayment(this.form.id);
        })
        .finally(() => {
          this.loading = false;
          this.isDisabledBtnComment = false;
        });
    },
    getCommentsPayment(id) {
      this.loading = true;
      const [sort_column, sort_dir] = ['created_at', 'asc'];
      this.$store
        .dispatch('getPaymentComment', {
          id,
          sort_column,
          sort_dir,
        })
        .then((res) => {
          this.comments = res.payload;
          setTimeout(() => {
            const over = document.getElementsByClassName('comment-overflow')[0];
            if (over) over.scrollTop = 9999;
          }, 100);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    currencyFormatter(code) {
      if (!code) {
        return '';
      }

      const miscCurrencies = this.$store.state.misc.currencies;
      const currency = miscCurrencies.find((c) => code.toLowerCase() === c.code?.toLowerCase());

      return currency ? currency.code.toUpperCase() : '';
    },

    formatStatus(status) {
      return status && `<span class="${classes[status]}">${this.$t(`mediaBuying.payments.status.${status}`)}</span>`;
    },
  },
};
</script>

<style lang="scss">
.el-upload__input {
  display: block;
}

.textarea_error .el-textarea__inner {
  box-shadow: 0 0 0 1px #ff5c70 inset;
}

.statuses {
  border-top: 1px solid #dee2e6;
}
</style>
<style lang="scss" scoped>
.media-buying-modal.paymentStatusSuccess {
  // /deep/ {
  // vue3-migration -- удаляем /deep/
  :deep(.modal-dialog .modal-content) {
    width: 360px;
  }

  // }
}

.successPaymentFooter {
  display: flex;
  justify-content: center;
  flex: 1;
}

.successPaymentBlock {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 32px;
  padding-bottom: 32px;

  .title {
    margin-top: 16px;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.71;
    padding-left: 8px;
    padding-right: 8px;
  }

  .message {
    margin-top: 8px;
    font-size: 14px;
    line-height: 1.71;
    padding-left: 18px;
    padding-right: 18px;
    text-align: center;

    // /deep/ {
    // vue3-migration -- удаляем /deep/
    :deep(span) {
      color: var(--color-text-green);
    }

    // }
  }
}
</style>
